import React from "react";
import { Form, Input } from "antd";

const BranchShopName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="name"
      label="Shop Name"
      rules={[
        {
          required: true,
          message: "Please input shop name",
        },
      ]}
    >
      <Input
        showCount
        maxLength={30}
        placeholder="Shop Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BranchShopName;
